/* globals google */
class AmenitiesMarker {
  constructor (place, template, pinTemplatePromise) {
    this.place = place;
    this.template = template;
    this.pinTemplatePromise = pinTemplatePromise;

    this.map = {};
    this.infoWindow = false;
  }

  setTemplate (template) {
    this.template = template;
    return this;
  }

  setInfoWindow (infoWindow) {
    this.infoWindow = infoWindow;
    return this;
  }

  getInfoWindow () {
    return this.infoWindow;
  }

  loadInfoWindow (marker) {
    if (this.infoWindow === false) {
      return;
    }

    if (this.pinTemplatePromise) {
      this.pinTemplatePromise(this.place).then((template) => {
        this.setTemplate(template);
        this.showInfoWindow(marker);
      }).catch(() => {});

      return;
    }

    return this.showInfoWindow(marker);
  }

  showInfoWindow (marker) {
    this.infoWindow.close();
    this.infoWindow.setContent(this.template);
    this.infoWindow.open(marker.getMap(), marker);
  }

  setMap (map) {
    this.map = map;
    return this;
  }

  getMarker () {
    const marker = new google.maps.Marker({
      position: this.place.geometry.location,
      optimized: false
    });

    marker.addListener('mouseover', () => {
      this.loadInfoWindow(marker);
    });

    marker.addListener('mousedown', () => {
      this.loadInfoWindow(marker);
    });

    if (this.map !== {}) {
      marker.setMap(this.map);
    }

    return marker;
  }
}

module.exports = AmenitiesMarker;
